import React from 'react';
import { FileCheck2 } from 'lucide-react';
import { Card } from '@/components/ui/card';

const h = (m) => `${Math.floor((m || 0) / 60)}h${String(Math.round((m || 0) % 60)).padStart(2, '0')}`;
const Row = ({ k, children }) => <div className="grid grid-cols-[110px_1fr] gap-2 text-sm"><span className="text-slate-500 font-semibold">{k}</span><div>{children}</div></div>;

export const ReadySummary = ({ s, by, at }) => {
  if (!s) return null;
  return (
    <Card className="p-4 border-2 border-emerald-400 bg-emerald-50/50 space-y-2" data-testid="ready-summary">
      <div className="flex items-center gap-2"><FileCheck2 className="w-5 h-5 text-emerald-700" /><h3 className="font-bold">Rapport atelier — véhicule prêt</h3>
        {at && <span className="ml-auto text-xs text-slate-500">{by} · {new Date(at).toLocaleString('fr-CH')}</span>}</div>
      <Row k="Temps"><span data-testid="ready-summary-time">{s.mechanics.map(m => `${m.name} ${h(m.minutes)}`).join(' · ') || 'Aucun pointage'} — <b>total {h(s.total_minutes)}</b></span></Row>
      {s.operations.length > 0 && <Row k="Travaux">{s.operations.join(', ')}</Row>}
      {s.parts.length > 0 && <Row k="Pièces"><ul data-testid="ready-summary-parts">{s.parts.map((p, i) => <li key={i}>{p.name} × {p.quantity}{p.supplier && <span className="text-slate-500"> ({p.supplier})</span>}</li>)}</ul></Row>}
      {s.fluids.length > 0 && <Row k="Fluides"><span data-testid="ready-summary-fluids">{s.fluids.map(f => `${f.name}${f.spec ? ` ${f.spec}` : ''} ${f.qty} L`).join(' · ')}</span></Row>}
      {s.level_topups.length > 0 && <Row k="Appoints">{s.level_topups.map(x => `${x.name} ${x.qty} L`).join(' · ')}</Row>}
      {s.services.length > 0 && <Row k="Services">{s.services.join(', ')}</Row>}
      {s.recommendations && <Row k="Conseils"><span className="whitespace-pre-line">{s.recommendations}</span></Row>}
    </Card>
  );
};
